
import { mapGetters, mapMutations } from 'vuex';
import * as types from '@/types';
import { getMessageGroups } from '@/api/message';
import { getMemberInfo } from '@/api/user';
import { isFirefox } from '~/utils/util';
export default {
  props: {
    // 点击其他区域隐藏时 需要show.sync传参
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    width: {
      type: String | Number,
      default: '395',
    },
    messageId: {
      // 点击其他区域隐藏需要设置id
      type: String,
      default: '',
    },
    isScroll: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      messageList: [],
    };
  },
  computed: {
    ...mapGetters('user', ['userId']),
    messageRef() {
      return `MessageBar${this.messageId || ''}`;
    },
    calWidth() {
      const reduceWidth = isFirefox() ? 108 : 96;
      return this.width - reduceWidth + 'px';
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.getList();
      }
    },
    $route() {
      setTimeout(() => {
        if (this.show) {
          this.getList();
        }
      }, 0);
    },
  },
  mounted() {
    this.getList();
    this.messageId && document.body.addEventListener('click', this.close);
  },
  beforeDestroy() {
    this.messageId && document.body.removeEventListener('click', this.close);
  },
  methods: {
    /**
     * @description 获取或更新消息通知列表
     */
    async getList(status) {
      const res = await this.$axios(getMessageGroups());
      if (res.result) {
        this.messageList = res.result || [];
      }
      this.updateMyInfo();
    },
    /**
     * @description 更新信息
     */
    updateMyInfo() {
      this.$axios(getMemberInfo()).then(res => {
        if (res.result) {
          this.updateLoginInfo(res.result);
        }
      });
    },
    /**
     * @description 关闭消息通知弹框
     */
    close(e) {
      if (
        this.$refs &&
        this.$refs[this.messageRef] &&
        !this.$refs[this.messageRef].contains(e.target)
      ) {
        this.$emit('update:show', false);
      }
    },
    /**
     * @description 获取消息类型
     */
    getType(link) {
      const linkArr = link.split('/');
      const type = linkArr[linkArr.length - 1];

      return type;
    },
    /**
     * @description 获取url
     */
    getUrl(link) {
      const linkArr = link.split('/');
      const type = linkArr[linkArr.length - 1];
      const sourceType = linkArr[linkArr.length - 2];

      return `/message?sourceType=${sourceType}&type=${type}`;
    },
    ...mapMutations('user', {
      updateLoginInfo: types.SET_LOGININFO,
    }),
  },
};
